import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle, Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

// Mikrozement Gallery Image (Bathroom)
const MIKROZEMENT_IMAGE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_9cba13cf-f2db-4d29-a3e0-dbd97dd97a4f/artifacts/tz2ewbre_8231ed7c-2aed-48bc-ad7f-f4aa0aea0117.jpeg";

const MikrozementPage = () => {
  const vorteile = [
    "Nahtlose Oberflächen",
    "Moderne Optik",
    "Individuelle Gestaltung",
    "Extrem belastbar",
    "Pflegeleicht",
    "Vielfältige Farben"
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-slate-900 to-slate-800" data-testid="mikrozement-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-slate-400 hover:text-white mb-8 transition-colors"
            data-testid="back-link"
          >
            <ArrowLeft size={20} className="mr-2" />
            Zurück zur Startseite
          </Link>
          
          <div className="text-center">
            <span className="font-body text-amber-500 font-semibold uppercase tracking-wider text-sm">
              Premium-Beschichtung
            </span>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white mt-4 mb-6">
              Mikrozement
            </h1>
            <p className="font-body text-slate-300 text-lg max-w-3xl mx-auto">
              Nahtlose Oberflächen. Moderne Optik. Individuelle Gestaltung – 
              Mikrozement verleiht Böden, Wänden und Möbeln einen einzigartigen, 
              zeitlosen Charakter.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-testid="mikrozement-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            
            {/* Content */}
            <div>
              <h2 className="font-heading text-3xl sm:text-4xl font-bold uppercase tracking-tight text-slate-900 mb-6">
                Die perfekte Oberfläche für anspruchsvolle Räume
              </h2>
              <p className="font-body text-slate-600 leading-relaxed mb-6 text-lg">
                Mikrozement ist eine innovative Beschichtung, die sich durch ihre fugenlose Verarbeitung 
                und hohe Belastbarkeit auszeichnet. Ob auf Böden, Wänden, Treppen oder sogar Möbeln – 
                Mikrozement schafft elegante, moderne Oberflächen mit industriellem Charme.
              </p>
              <p className="font-body text-slate-600 leading-relaxed mb-8 text-lg">
                Mit einer Vielzahl an Farben und Texturen bieten wir Ihnen individuelle Gestaltungsmöglichkeiten, 
                die perfekt zu Ihrem Stil passen. Die extrem dünne Auftragsstärke ermöglicht eine nahtlose 
                Renovierung – auch über bestehende Flächen.
              </p>
              
              {/* Vorteile */}
              <div className="mb-10">
                <h3 className="font-heading text-xl font-semibold uppercase tracking-tight text-slate-900 mb-4">
                  Ihre Vorteile
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {vorteile.map((vorteil, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <div className="w-8 h-8 bg-amber-500/20 rounded-sm flex items-center justify-center flex-shrink-0">
                        <CheckCircle size={18} weight="fill" className="text-amber-500" />
                      </div>
                      <span className="font-body text-slate-700">{vorteil}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* CTA Button */}
              <a 
                href="https://wa.me/4917672636169?text=Hallo%2C%20ich%20interessiere%20mich%20für%20Mikrozement."
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button 
                  className="btn-gold text-white rounded-sm font-bold uppercase tracking-wide px-8 py-6 h-auto"
                  data-testid="mikrozement-cta-whatsapp"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Projekt anfragen
                </Button>
              </a>
            </div>
            
            {/* Single Image */}
            <div data-testid="mikrozement-gallery">
              <div className="overflow-hidden rounded-sm shadow-lg">
                <img 
                  src={MIKROZEMENT_IMAGE} 
                  alt="Mikrozement Badezimmer"
                  className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500"
                  data-testid="mikrozement-image-1"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ansprechpartner Section */}
      <section className="py-20 bg-slate-50" data-testid="mikrozement-kontakt">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold uppercase tracking-tight text-slate-900 mb-4">
              Ihre Ansprechpartner
            </h2>
            <p className="font-body text-slate-600 text-lg max-w-2xl mx-auto">
              Kontaktieren Sie uns für eine unverbindliche Beratung zu Ihrem Mikrozement-Projekt.
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {/* Sinan Kaya */}
              <div className="bg-white rounded-sm p-6 border border-slate-200 shadow-sm" data-testid="contact-card-sinan">
                <p className="font-heading text-2xl font-bold text-slate-900 mb-1">
                  Sinan Kaya
                </p>
                <p className="font-body text-sm text-slate-500 mb-2">
                  Projektleitung & fachliche Kundenberatung
                </p>
                <a 
                  href="mailto:pureepox@gmail.com" 
                  className="font-body text-slate-600 hover:text-sky-700 text-sm mb-6 block"
                >
                  pureepox@gmail.com
                </a>
                
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-sky-700 rounded-sm flex items-center justify-center flex-shrink-0">
                    <Phone size={18} weight="bold" className="text-white" />
                  </div>
                  <div>
                    <p className="font-body text-xs text-slate-500 uppercase tracking-wider">Telefon</p>
                    <a 
                      href="tel:+4916092653278" 
                      className="font-body text-sky-700 hover:text-sky-800 font-medium"
                      data-testid="kontakt-sinan-phone"
                    >
                      +49 160 92653278
                    </a>
                  </div>
                </div>
              </div>
              
              {/* Semih Aytekin */}
              <div className="bg-white rounded-sm p-6 border border-slate-200 shadow-sm" data-testid="contact-card-semih">
                <p className="font-heading text-2xl font-bold text-slate-900 mb-1">
                  Semih Aytekin
                </p>
                <p className="font-body text-sm text-slate-500 mb-2">
                  Projektplanung, Organisation & Kundenmanagement
                </p>
                <a 
                  href="mailto:pureepox@gmail.com" 
                  className="font-body text-slate-600 hover:text-sky-700 text-sm mb-6 block"
                >
                  pureepox@gmail.com
                </a>
                
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-green-500 rounded-sm flex items-center justify-center flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                  </div>
                  <div>
                    <p className="font-body text-xs text-slate-500 uppercase tracking-wider">WhatsApp</p>
                    <a 
                      href="https://wa.me/4917672636169?text=Hallo%2C%20ich%20interessiere%20mich%20für%20Mikrozement."
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-body text-green-600 hover:text-green-700 font-medium"
                      data-testid="kontakt-semih-whatsapp"
                    >
                      Nachricht senden
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Zusätzliche Infos */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Adresse */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-sky-700 rounded-sm flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} weight="bold" className="text-white" />
                </div>
                <div>
                  <h4 className="font-heading text-sm font-semibold uppercase tracking-tight text-slate-900 mb-1">
                    Adresse
                  </h4>
                  <p className="font-body text-slate-600 text-sm leading-relaxed">
                    Steubenstraße 23<br />
                    35576 Wetzlar
                  </p>
                </div>
              </div>
              
              {/* E-Mail */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-sky-700 rounded-sm flex items-center justify-center flex-shrink-0">
                  <EnvelopeSimple size={24} weight="bold" className="text-white" />
                </div>
                <div>
                  <h4 className="font-heading text-sm font-semibold uppercase tracking-tight text-slate-900 mb-1">
                    E-Mail
                  </h4>
                  <a 
                    href="mailto:pureepox@gmail.com" 
                    className="font-body text-sky-700 hover:text-sky-800 text-sm"
                  >
                    pureepox@gmail.com
                  </a>
                </div>
              </div>
              
              {/* Servicegebiet */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-sky-700 rounded-sm flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} weight="bold" className="text-white" />
                </div>
                <div>
                  <h4 className="font-heading text-sm font-semibold uppercase tracking-tight text-slate-900 mb-1">
                    Servicegebiet
                  </h4>
                  <p className="font-body text-slate-600 text-sm">
                    Deutschlandweit
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-900" data-testid="mikrozement-cta-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold uppercase tracking-tight text-white mb-6">
            Bereit für Ihre neue Oberfläche?
          </h2>
          <p className="font-body text-slate-300 text-lg mb-10 max-w-2xl mx-auto">
            Kontaktieren Sie uns für eine unverbindliche Beratung. Wir erstellen Ihnen ein 
            individuelles Angebot für Ihr Mikrozement-Projekt.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a 
              href="https://wa.me/4917672636169?text=Hallo%2C%20ich%20interessiere%20mich%20für%20Mikrozement."
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="btn-gold text-white rounded-sm font-bold uppercase tracking-wide px-10 py-6 h-auto w-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Projekt anfragen
              </Button>
            </a>
            <a href="tel:+4916092653278">
              <Button 
                variant="outline"
                className="border-2 border-white text-white hover:bg-white/10 rounded-sm font-semibold uppercase tracking-wide px-10 py-6 h-auto w-full"
              >
                Anrufen
              </Button>
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default MikrozementPage;
